<template>
    <div>
        <div style="font-size: 15px">佣金比例区间</div>
        <div style="margin-top: 10px;">
            <van-row>
                <van-col span="11">
                    <van-field
                            style="border-radius:20px; padding: 5px 5px; box-shadow: 0px 0px 2px #333333 inset;"
                            v-model="commission_share_min"
                            placeholder="最低比例"
                            clearable
                            type="number"
                            input-align="center"
                            @input="inputMin"
                    />
                </van-col>
                <van-col span="2">
                    <div style="text-align: center; height: 32px; line-height: 32px">—</div>
                </van-col>
                <van-col span="11">
                    <van-field
                            style="border-radius:20px; padding: 5px 5px; box-shadow: 0px 0px 2px #333333 inset;"
                            v-model="commission_share_max"
                            placeholder="最高比例"
                            clearable
                            type="number"
                            input-align="center"
                            @input="inputMax"
                    />
                </van-col>
            </van-row>
        </div>
        <div style="margin-top: 10px; text-align: center; display: flex; padding: 0px 10px">
            <van-checkbox v-model="smaller_checked" style="flex: 1" shape="round" checked-color="#ff0000" @click="smallerThen_10">
                小于10%
            </van-checkbox>

            <van-checkbox v-model="between_checked" style="flex: 1" shape="round" checked-color="#ff0000" @click="between_10_30">
                10% - 30%
            </van-checkbox>
            <van-checkbox v-model="greater_checked" style="" shape="round" checked-color="#ff0000" @click="greaterThen_30">
                大于30%
            </van-checkbox>
<!--            <van-row>-->
<!--                <van-col span="8">-->
<!--&lt;!&ndash;                    <van-button  size="small" :type="type_smaller" style="width: 90%" @click="smallerThen_10">小于10%</van-button>&ndash;&gt;-->
<!--                    <van-checkbox v-model="smaller_checked" shape="round" checked-color="#ff0000" @click="smallerThen_10">-->
<!--                        小于10%-->
<!--                    </van-checkbox>-->
<!--                </van-col>-->
<!--                <van-col span="8">-->
<!--&lt;!&ndash;                    <van-button size="small" :type="type_between" style="width: 90%" @click="between_10_30">10% - 30%</van-button>&ndash;&gt;-->
<!--                    <van-checkbox v-model="between_checked" shape="round" checked-color="#ff0000" @click="between_10_30">-->
<!--                        10% - 30%-->
<!--                    </van-checkbox>-->
<!--                </van-col>-->
<!--                <van-col span="8">-->
<!--&lt;!&ndash;                    <van-button size="small" :type="type_greater" style="width: 90%" @click="greaterThen_30">大于30%</van-button>&ndash;&gt;-->
<!--                    <van-checkbox v-model="greater_checked" shape="round" checked-color="#ff0000" @click="greaterThen_30">-->
<!--                        大于30%-->
<!--                    </van-checkbox>-->
<!--                </van-col>-->
<!--            </van-row>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_limit_commission_share_model",

        data(){
            return{
                commission_share_min: '',
                commission_share_max: '',

                type_smaller: 'default',
                type_between: 'default',
                type_greater: 'default',

                smaller_checked: false,
                between_checked: false,
                greater_checked: false,
            }
        },

        methods:{
            inputMin(){
                this.emitData(this.commission_share_min, this.commission_share_max);

                // this.type_smaller = 'default';
                // this.type_between = 'default';
                // this.type_greater = 'default';
                this.smaller_checked = false;
                this.between_checked = false;
                this.greater_checked = false;
            },
            inputMax(){
                this.emitData(this.commission_share_min, this.commission_share_max);

                // this.type_smaller = 'default';
                // this.type_between = 'default';
                // this.type_greater = 'default';
                this.smaller_checked = false;
                this.between_checked = false;
                this.greater_checked = false;
            },

            emitData(_min, _max){
                this.$emit("getCommissionShareLimit", {
                    commission_share_min_str: _min,
                    commission_share_max_str: _max
                })
            },

            smallerThen_10(){
                // if(this.type_smaller === 'warning'){
                //     this.reset();
                // }else {
                //     this.type_smaller = 'warning';
                //     this.type_between = 'default';
                //     this.type_greater = 'default';
                //
                //     this.commission_share_min = '';
                //     this.commission_share_max = '10';
                // }
                if(this.smaller_checked){
                    this.smaller_checked = true;
                    this.between_checked = false;
                    this.greater_checked = false;

                    this.commission_share_min = '';
                    this.commission_share_max = '10';
                }else{
                    this.reset();
                }

                this.emitData(this.commission_share_min, this.commission_share_max);
            },
            between_10_30(){
                // if(this.type_between === 'warning'){
                //     this.reset();
                // }else{
                //     this.type_smaller = 'default';
                //     this.type_between = 'warning';
                //     this.type_greater = 'default';
                //
                //     this.commission_share_min = '10';
                //     this.commission_share_max = '30';
                // }

                if(this.between_checked){
                    this.smaller_checked = false;
                    this.between_checked = true;
                    this.greater_checked = false;

                    this.commission_share_min = '10';
                    this.commission_share_max = '30';
                }else{
                    this.reset();
                }

                this.emitData(this.commission_share_min, this.commission_share_max);
            },
            greaterThen_30(){
                // if(this.type_greater === 'warning'){
                //     this.reset();
                // }else{
                //     this.type_smaller = 'default';
                //     this.type_between = 'default';
                //     this.type_greater = 'warning';
                //
                //     this.commission_share_min = '30';
                //     this.commission_share_max = '';
                // }
                if(this.greater_checked){
                    this.smaller_checked = false;
                    this.between_checked = false;
                    this.greater_checked = true;

                    this.commission_share_min = '30';
                    this.commission_share_max = '';
                }else{
                    this.reset();
                }

                this.emitData(this.commission_share_min, this.commission_share_max);
            },

            reset(){
                this.commission_share_min = '';
                this.commission_share_max = '';

                // this.type_smaller = 'default';
                // this.type_between = 'default';
                // this.type_greater = 'default';
                this.smaller_checked = false;
                this.between_checked = false;
                this.greater_checked = false;
            }
        }
    }
</script>

<style scoped>

</style>